<template>
  <div class="form-comment">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      style="padding-right:50px;padding-bottom:40px;padding-left:50px"
    >
      <el-form-item label="评分">
        <el-rate v-model="form.stars"></el-rate>
      </el-form-item>
      <el-form-item label="" prop="content">
        <el-input type="textarea" :rows="8" v-model="form.content"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input
          style="width:250px"
          placeholder="请输入验证码"
          v-model="form.code"
          class="input-code"
        >
          <template #append>
            <s-identify @refreshCode="refreshCode" />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">发表评论</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SIdentify from "@/components/Identify/identify";
import { remark } from "@/api/user";
export default {
  props: {
    type: {
      type: String,
      default: "DATA"
    },
    subjectId: {
      type: String,
      default: "402881f279ffad02017a0f9faa62000d"
    }
  },
  components: {
    SIdentify
  },
  data() {
    return {
      form: {
        code: "",
        stars: "",
        content: ""
      },
      rules: {
        content: [
          { required: true, message: "请输入评论内容", trigger: "blur" },
          {
            min: 2,
            max: 500,
            message: "长度在 2 到 500 个字符",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入验证码"));
              } else if (value !== this.code) {
                callback(new Error("验证码不正确!"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      code: ""
    };
  },
  methods: {
    refreshCode(code) {
      this.code = code;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this[formName].type = this.type;
          this[formName].subjectId = this.subjectId;
          let { message } = await remark(this[formName]);
          this.$message({
            message: message,
            type: "success"
          });
          this.$refs[formName].resetFields();
          this[formName].stars = 0;
          this.$forceUpdate();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form .el-form-item:first-child {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
